import { numberToPrettyString } from '@cian/utils';

export const getCoworkingWorkplaceCountLabel = (workplaceCount: number) => {
  if (!workplaceCount) {
    return null;
  }

  return `${numberToPrettyString(workplaceCount)} чел.`;
};
